export default __webpack_public_path__ + "static/backgroundMobile@2x-e781908a336736765dd413c7df98ab7e.jpg";